import styles from './FJClothesChangerRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer.jsx';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import DownloadIcon from '../../../assets/svg/download-black.svg?react';
import classNames from 'classnames';
import FJConstant from '../../../constants/FJConstant.js';
import FJUtil from '../../../util/FJUtil.js';
import VideoGradientIcon from '../../../assets/svg/video-gradient.svg?react';
import { useMemo } from 'react';

const FJClothesChangerRight = props => {
    const {
        uploadImg,
        setIsDraggingFile,
        reGenerate,
        download,
        downloadEditImageLoading,
        taskStatus,
        headerTabIndex,
        isCanDownload,
        imageToVideo,
    } = props;

    const currentTag = FJLocalStore.currentTag();

    const rightChildren = useMemo(() => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return null;
        }

        if (window.isEditPage) return null;

        return (
            <div className={styles.right_btn_box}>
                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.image_to_video_btn)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('image-to-video')}
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon className={styles.image_to_video_icon} />}
                />
                <FJButton
                    onClick={download}
                    className={classNames(styles.download, downloadEditImageLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadEditImageLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [download, downloadEditImageLoading, headerTabIndex, imageToVideo, isCanDownload, taskStatus, currentTag]);

    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={styles.app_right}>
            <FJDisplayHeaderContainer hideCancelButton={true} rightChildren={rightChildren} />
            <FJCreationPanelContainer activeHeaderTabIndex={FJConstant.CREATIONS} onRetry={reGenerate} />
            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};
FJClothesChangerRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    reGenerate: PropTypes.func,
    download: PropTypes.func,
    downloadEditImageLoading: PropTypes.bool,
    taskStatus: PropTypes.string,
    headerTabIndex: PropTypes.string,
    isCanDownload: PropTypes.bool,
    imageToVideo: PropTypes.func,
};
export default FJClothesChangerRight;
